const apiUrl = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export const postPreSignup = async (postData) => {
  try {
    const endpoint = `${apiUrl?.replace(/\/$/, '')}/pre-signup`;
    const response = await fetch(endpoint, {
      method: "POST",
      mode: "cors",
      headers: {
        "x-api-key": `${apiKey}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });

    const contentType = response.headers.get("content-type") || "";
    const responseBody = contentType.includes("application/json")
      ? await response.json()
      : await response.text();

    if (!response.ok) {
      if (typeof responseBody === "string") {
        if (response.status === 404) {
          throw new Error("Pre-signup endpoint not found. Check REACT_APP_API_URL and confirm the backend route is available.");
        }

        throw new Error(`Pre-signup request failed with status ${response.status}.`);
      }

      const errorMessage = responseBody?.data?.status?.message ||
        responseBody?.data?.status?.error ||
        "We couldn't send your details right now. Please try again.";

      throw new Error(errorMessage);
    }

    if (typeof responseBody === "string") {
      throw new Error("Pre-signup endpoint returned a non-JSON response.");
    }

    return responseBody.data;
  } catch (error) {
    console.error(error);
    throw new Error(error?.message || "We couldn't send your details right now. Please try again.");
  }
};
